import { Pipe, PipeTransform } from '@angular/core';
import { getExportTypeLabel } from '../utils/export-type-labels';

@Pipe({
    name: 'exportTypeLabel',
    standalone: false
})
export class ExportTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    return getExportTypeLabel(value);
  }
}
